(function () {
  const breakpoint_tablet = 990;
  const containerWidth = window.innerWidth;
  const isMobile = containerWidth < breakpoint_tablet;
  const cartFooterLayout = document.querySelector('#main-cart-footer')?.getBoundingClientRect();
  if (!isMobile && cartFooterLayout) {
    document.querySelector('.pd-sticky-bar').style.setProperty("--left-desktop", cartFooterLayout.left + 'px');
    document.querySelector('.pd-sticky-bar').style.setProperty("--width-desktop", cartFooterLayout.width + 'px');
  }

  function getGwpDataFromDom(root = document) {
    const dataEl = root.querySelector('#pd-cart__api-gwp');
    if (!dataEl) {
      return null;
    }

    const raw = dataEl.textContent || dataEl.innerHTML;
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw.replaceAll(' ', '').replaceAll('\n', ''));
      parsed.forEach((obj, i) => {
        console.log(`[GWP Product] campaign[${i}] "${obj.campaignLabel}" cartItemsCollections:`, obj.cartItemsCollections || '(empty)');
      });
      return parsed;
    } catch (error) {
      console.warn('GWP data parse failed', error);
      return null;
    }
  }

  async function refreshCartDrawerContents() {
    const cartDrawerItems = document.getElementById('cart-drawer-items');
    if (!cartDrawerItems) {
      return;
    }

    try {
      const response = await fetch(`${routes.cart_url}?view=items-modal`);
      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const updated = html.getElementById('cart-drawer-items');
      if (updated) {
        cartDrawerItems.innerHTML = updated.innerHTML;
      }
    } catch (error) {
      console.warn('Cart drawer refresh failed', error);
    }
  }

  async function removeFreeGiftWithGWP(gwpArr = []) {
    const updates = {}

    for (let gwpObj of gwpArr) {
      if (!gwpObj.shouldAddGiftToCart && !gwpObj.conditionMet) {
        const variantIds = gwpObj.selectedGiftVariantId.split(',').filter(x => x);
        for (let variantId of variantIds) {
          updates[variantId] = 0;
        }
      }
    }

    // remove added gifts not available in all reward collections
    const allGiftVariantIds = gwpArr.flatMap(x => x.giftVariantId.split(',').filter(x => x));
    const addedGiftVariantIds = [...document.querySelectorAll('cart-remove-button[data-gwp]')].map(ele => ele.getAttribute("data-variantid"));
    const addedGiftVariantIdsNotInAllGifts = addedGiftVariantIds.filter(variantId => !allGiftVariantIds.includes(variantId));
    if(addedGiftVariantIdsNotInAllGifts.length) {
      for (let variantId of addedGiftVariantIdsNotInAllGifts) {
        updates[variantId] = 0;
      }
    }

    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      }).then(res => res.json())
      .then(resJson => {
        if (resJson.item_count === 0) {
          document.querySelector('#main-cart-items-wrapper')?.classList.add('is-empty');
        }
      })

      await refreshCartDrawerContents();

      Object.keys(updates).forEach(variantId => {
        const ELM_removeBtn = document.querySelector(`[data-variantid="${ variantId }"]`);
        if (!ELM_removeBtn) {
          return;
        }
        const ELM_cartItem = ELM_removeBtn.closest('tr.cart-item');
        ELM_cartItem?.remove();
      })
    }

    document.querySelector('#main-cart-items')?.classList.remove('loading');
  }

  // remove free gift if gwp condition isnt met
  function handleGWPOnceCartUpdated(isFirstLoad) {
    const domGwpArr = getGwpDataFromDom();
    if (isFirstLoad) {
      if (!domGwpArr) {
        return;
      }
      const gwpArr = domGwpArr;
      removeFreeGiftWithGWP(gwpArr);
      return;
    }

    if (domGwpArr) {
      removeFreeGiftWithGWP(domGwpArr);
      return;
    }

    fetch(`/cart`)
      .then((response) => response.text())
      .then(async (resp) => {
        const parser = new DOMParser();
        const cartDom = parser.parseFromString(resp, "text/html");
        const gwpArr = getGwpDataFromDom(cartDom);
        if (gwpArr) {
          removeFreeGiftWithGWP(gwpArr);
        }
      });
  }

  handleGWPOnceCartUpdated(true);
  document.addEventListener('cart::updated', handleGWPOnceCartUpdated);

  // listeners to variant options in GWP carousel
  document.querySelectorAll('.product-card-wrapper').forEach(wrapper => {
    const variantsData = wrapper.querySelector('#variants-data')?.textContent;
    if (!variantsData) {
      return;
    }
    const variants = JSON.parse(variantsData);
    const productForm = wrapper.querySelector('product-form form');

    wrapper.querySelectorAll('.product-form__input').forEach(formInput => {
      const radioOptions = formInput.querySelectorAll('[type="radio"]');

      radioOptions.forEach(ele => {
        ele.addEventListener('change', e => {
          const optionValues = [...wrapper.querySelectorAll('.product-form__input [type="radio"]:checked')].map(x => x.value);
          const existing = variants.find(x =>
            optionValues.every(val => x.options.includes(val))
          );
          // change variant id to add to cart
          if (productForm && existing) {
            productForm.querySelector('[name=id]').value = existing.id;
          }
        })
      });

      if (radioOptions.length) {
        // automatically choose the first option
        formInput.querySelector('[type="radio"] + label')?.click();
      } else {
        formInput.remove();
      }
    });

    wrapper.querySelectorAll('.pd-form-select').forEach(formInput => {
      const selectOption = formInput.querySelector('[name="selectVariant"]');
      if(!selectOption) return;
      selectOption.addEventListener('change', e => {
        const variantId = e?.target?.value;
        // change variant id to add to cart
        if (productForm && variantId) {
          productForm.querySelector('[name=id]').value = variantId;
        }
      });
    });
  })

  // set max-height for gwp card heading
  setTimeout(() => {
    const maxHeight = [...document.querySelectorAll('.pd-cart-gwp .card__heading a')].map(x => x.getBoundingClientRect()?.height).sort().at(-1);
    document.querySelectorAll('.pd-cart-gwp .card__information').forEach(x => x.style.setProperty(`--title-height`, `${maxHeight + 5}px`))
  }, 1000);

})();
